import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  TextInput,
  SelectInput,
  Filter,
  ReferenceInput,
  BooleanField,
  DateField,
  ArrayField,
  SingleFieldList,
  ChipField,
  SelectField,
  DateInput,
  FunctionField,
  DeleteButton,
  BooleanInput,
} from "react-admin";
import CustomActions from "../../../components/CustomActions";
import { isTestUserChoice, statusUserChoice, typeDocumentChoice } from "../../../constants/choices";
import { ListPagination } from "../../../utils";
import { exporter, exporterConfirmedBox } from "../utils";
import { USER_ROLES_ENUM, USER_GENDER_ENUM } from "../enums/";

const widthSelect = { width: 200 };

const roleUserChoice = [
  { id: USER_ROLES_ENUM.ADMINISTRATOR, name: 'Administrator' },
  { id: USER_ROLES_ENUM.NORMAL, name: 'Normal' },
];


const UserFilter = (props) => {

  return (
    <Filter {...props}>
      <TextInput label="Documento" source="document" alwaysOn />
      <TextInput label="CPF" source="cpf" />
      <TextInput label="E-mail" source="email" />
      <DateInput label="Cadastrado de" source="registeredAt.gte"/>
      <DateInput label="Cadastrado até" source="registeredAt.lte" />
      <SelectInput
        style={widthSelect}
        label="Status do Usuário"
        source="statusUserId"
        choices={statusUserChoice}
      />
      <SelectInput
        style={widthSelect}
        label="Tipo de Documento"
        source="typeUserId"
        choices={typeDocumentChoice}
      />
      <SelectInput
        style={widthSelect}
        label="Usuário de teste"
        source="isTestUser"
        choices={isTestUserChoice}
      />
      <SelectInput
      style={widthSelect}
      label="Função do Usuário"
      source="roleUserId"
      choices={roleUserChoice}
    />
    <BooleanInput source="registeredAt.isNull" label="Sem data de cadastro"/>
  </Filter>
  );
};

const UsersWithConfirmedBoxFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Ciclo" source="cycle.id" alwaysOn />
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      perPage={999}
      resource="lab"
      label="Laboratório"
      source="cycle.labId"
      reference="labs"
    >
      <SelectInput label="Laboratório" optionText="name" optionValue="id" />
    </ReferenceInput>
  </Filter>
);

export const UserList = (props) => (
  <List
    hasCreate={true}
    bulkActionButtons={<div />}
    perPage={25}
    title="Lista de Usuários"
    actions={<CustomActions />}
    exporter={exporter}
    filters={<UserFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField label="Sobrenome" source="lastName" />
      <EmailField label="E-mail" source="email" />
      <TextField sortable={false} label="Tipo de Documento" source="typeUser.name" />
      <TextField label="Documento" source="document" />
      <TextField label="CPF" source="cpf" />
      <TextField label="Telefone" source="phone" />
      <TextField label="Celular" source="cellPhone" />
      <FunctionField
          label="Gênero"
          sortBy="genderUserId"
          render={record => {
          if (record.genderUserId === USER_GENDER_ENUM.MALE) return 'male';
          if (record.genderUserId === USER_GENDER_ENUM.FEMALE) return 'female';
  }}
/>
      <BooleanField label="Notificações Autorizadas" source="authorizedNotifications" />
      <BooleanField label="Email Verificado" source="verifiedAccount" />
      <BooleanField label="Tutorial Visualizado" source="seenTutorial" />
      <FunctionField
        label="Função"
        sortBy="roleUserId"
        render={record => record.roleUserId === USER_ROLES_ENUM.NORMAL ? 'normal' : 'Administrator'}
      />
      <ArrayField sortable={false} label="Especialidade" source="specialtiesUsers">
        <SingleFieldList>
          <ChipField source="specialties.name" />
        </SingleFieldList>
      </ArrayField>
      <DateField label="Data de Criação" source="createdAt" />
      <DateField label="Data de Registro" source="registeredAt" />
      <DateField label="Último Login" source="lastLogin" />
      <SelectField label="Status do Usuário" source="statusUserId" choices={statusUserChoice} />
      <SelectField label="Usuario de teste" source="isTestUser" choices={isTestUserChoice} />
      <FunctionField
        render={record => record.roleUserId === USER_ROLES_ENUM.ADMINISTRATOR ? <DeleteButton record={record} /> : null}
      />
    </Datagrid>
  </List>
);

export const UsersWithConfirmedBoxList = (props) => (
  <List
    {...props}
    perPage={25}
    bulkActionButtons={<div />}
    title="Lista de Entregas Confirmadas"
    exporter={exporterConfirmedBox}
    actions={<CustomActions />}
    filters={<UsersWithConfirmedBoxFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
  >
    <Datagrid rowClick="edit">
      <TextField sortable={false} label="Nome" source="user.name" />
      <TextField sortable={false} label="Documento" source="user.document" />
      <TextField label="Ciclo" source="cycle.id" />
      <EmailField label="E-mail" sortable={false} source="user.email" />
      <ArrayField label="Laboratórios" sortable={false} source="labsList">
        <SingleFieldList>
          <ChipField source="lab" />
        </SingleFieldList>
      </ArrayField>
      <DateField label="Última Atualização" sortable={false} source="user.updatedAt" />
    </Datagrid>
  </List>
);

